import React, { useState } from 'react'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Accordion from './../Accordion/Accordion';

import abuDubaiImg from "./../../assets/about/abu-dhabi-seascape-with-skyscrapers (1) 2.png"
import aboout_image from "./../../assets/about/about_image.png"

import icon_1 from "./../../assets/icons/serv_icon_1.png"
import icon_2 from "./../../assets/icons/serv_icon_2.png"
import icon_3 from "./../../assets/icons/serv_icon_3.png"
import icon_4 from "./../../assets/icons/serv_icon_4.png"
import icon_5 from "./../../assets/icons/serv_icon_5.png"
import icon_6 from "./../../assets/icons/serv_icon_6.png"

import faq_img from "./../../assets/about/html-css-collage-concept-with-person 2.png"

import sponser_1 from './../../assets/home/sponser_1.jpg'
import sponser_2 from './../../assets/home/sponser_2.jpg'
import sponser_3 from './../../assets/home/sponser_3.jpg'
import sponser_4 from './../../assets/home/sponser_4.jpg'

import studio_green_logo from './../../assets/home/Logo-studio-green.svg'
import norto_logo from './../../assets/home/Logo-Norto.svg'
import out_of_the_stand_logo from './../../assets/home/Logo-Out Of The Sand Box.svg'
import points_one_logo from './../../assets/home/Logo-points-one.svg'
import { PiPhoneThin } from 'react-icons/pi';

const About = () => {
    const [activeTab, setActiveTab] = useState("approach_tab");
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    const accordionItems = [
        {
            title: "Question 1",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
        {
            title: "Question 2",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
        {
            title: "Question 3",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
        {
            title: "Question 4",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
    ];

    return (
        <div className="about">
            <div className="section_1 min-h-[50vh] bg-cover bg-no-repeat" style={{ backgroundImage: `url("${abuDubaiImg}")` }}>
                <div className="layer bg-gradient-to-r min-h-[50vh] from-main-light to-transparent flex items-center justify-content ">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="what-we-do col-span-3 lg:col-span-1 m-auto  w-5/6 lg:w-4/6">
                        <span className="bg-dark-navy bg-opacity-50 text-white p-1 px-2 border-l-4 border-l-cyan text-sm ">About Us</span>
                        <h2 className="text-3xl md:text-6xl text-white font-semibold my-3">Who We Are?</h2>
                    </motion.div>
                </div>
            </div>
            <div className="section_2 py-16">
                <div className="w-5/6 m-auto grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-10 items- justify-center">
                    <motion.div
                        initial={{
                            opacity: 0
                        }}
                        whileInView={{
                            opacity: 1
                        }}
                        transition={{
                            duration: 1.5
                        }}
                        viewport={{
                            once: true
                        }} className="image_box col-span-1 relative">
                        <img src={aboout_image} alt="" />
                    </motion.div>
                    <motion.div
                        initial={{
                            x: 200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="text_box col-span-1">
                        <span className="bg-gray-light bg-opacity-50 text-dark p-1 px-2 border-l-4 border-l-main-light text-sm ">About Us</span>
                        <h2 className="text-3xl md:text-3xl text-dark font-semibold my-3">Our Company Overview</h2>
                        <p className="text-sm text-gray font-Krub font-medium">Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition.</p>
                        <div className="button_content my-3">
                            <div className="btns flex gap-3">
                                <button onClick={() => handleTabClick("approach_tab")} className={classNames(activeTab === "approach_tab" ? 'bg-main-light text-white ' : 'bg-gray-light text-dark ',
                                    'w-fit text-sm font-krub  py-2 px-3 md:py-3 md:px-5 mt-2')}>Our Approach</button>
                                <button onClick={() => handleTabClick("mission_tab")} className={classNames(activeTab === "mission_tab" ? 'bg-main-light text-white ' : 'bg-gray-light text-dark ',
                                    'w-fit text-sm font-krub  py-2 px-3 md:py-3 md:px-5 mt-2')}>Our Mission</button>
                                <button onClick={() => handleTabClick("vision_tab")} className={classNames(activeTab === "vision_tab" ? 'bg-main-light text-white ' : 'bg-gray-light text-dark ',
                                    'w-fit text-sm font-krub  py-2 px-3 md:py-3 md:px-5 mt-2')}>Our Vision</button>
                            </div>
                            <div className="content text-sm text-gray font-medium font-Krub my-5">
                                {activeTab === "approach_tab" && <p>Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem quia voluptassit.</p>}
                                {activeTab === "mission_tab" && <p>Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt</p>}
                                {activeTab === "vision_tab" && <p>Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis .</p>}
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div >
            <div className="section_3 services bg-light py-20">
                <div className="w-5/6 lg:w-4/6 m-auto">
                    <div className="header text-center">
                        <span className="bg-gray-light bg-opacity-50 text-dark p-1 px-2 border-l-4 border-l-main-light text-sm ">What We Do</span>
                        <h2 className="text-3xl md:text-3xl text-dark font-semibold my-3">Our Services</h2>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_1} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 1</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 0.3,
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_2} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 2</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 0.6,
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_3} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 3</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 0.9
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_4} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 4</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 1.2
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_5} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 5</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 1.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_6} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 6</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                    </div>
                    <div className="w-full text-center mt-10">
                        <Link to="/services" className='bg-main-light w-fit text-sm font-krub text-white py-3 px-6 md:py-5 md:px-11 mt-2'>More Services</Link>
                    </div>
                </div>
            </div>
            <div className="section_4 faq bg-light py-20">
                <div className="w-5/6 m-auto grid grid-cols-1 lg:grid-cols-2 md:g gap-15 lg:gap-32">
                    <div className="text_box col-span-1">
                        <span className="bg-gray-light bg-opacity-50 text-dark p-1 px-2 border-l-4 border-l-main-light text-sm ">FAQ</span>
                        <h2 className="text-3xl md:text-3xl text-dark font-semibold my-3">Frequently Asked Questions</h2>
                        <Accordion items={accordionItems} />
                    </div>
                    <div className="bg-cover image_box col-span-1 relative min-h-[50vh]" style={{ backgroundImage: `url("${faq_img}")` }}>
                        <div className="talk bg-main  lg:w-2/3 p-10 absolute lg:-left-1/3 top-1/2 transform -translate-y-1/2 lg:translate-x-1/3">
                            <span className="bg-dark-navy bg-opacity-50 text-white p-1 px-2 border-l-4 border-l-cyan text-sm ">Let's Talk</span>
                            <p className="text-lg leading-6 text-white font-medium my-2">You Need Any Help? Get Free Consultation</p>
                            <div className="phone flex items-center justify-start gap-2">
                                <div className="text-main bg-white rounded-full p-4">
                                    <PiPhoneThin />
                                </div>
                                <div className="text-white text-sm font-light">
                                    <p>Have Any Questions?</p>
                                    <span>(971) 112 365 489</span>
                                </div>
                            </div>
                            <div className="w-full mt-7">
                                <Link to="/contact" className='bg-cyan w-fit text-sm text-main font-krub py-4 px-6 mt-2'>Contact Us</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="w-5/6 lg:w-4/6 m-auto">
                <div className="sponsors my-14 grid grid-cols-2 sm:grid-cols-4">
                    <motion.div
                        initial={{
                            x: -100,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black ">
                            <img src={studio_green_logo} alt="" />
                        </div>
                        <img src={sponser_1} alt="" />
                    </motion.div>
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black ">
                            <img src={norto_logo} alt="" />
                        </div>
                        <img src={sponser_2} alt="" />
                    </motion.div>
                    <motion.div
                        initial={{
                            x: 200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black">
                            <img src={points_one_logo} alt="" />
                        </div>
                        <img src={sponser_3} alt="" />
                    </motion.div>
                    <motion.div
                        initial={{
                            x: 100,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black">
                            <img src={out_of_the_stand_logo} alt="" />
                        </div>
                        <img src={sponser_4} alt="" />
                    </motion.div>
                </div>
            </div>
        </div >
    )
}

export default About